import { render, staticRenderFns } from "./order_done.vue?vue&type=template&id=d8f5c82e&scoped=true"
import script from "./order_done.vue?vue&type=script&lang=js"
export * from "./order_done.vue?vue&type=script&lang=js"
import style0 from "./order_done.vue?vue&type=style&index=0&id=d8f5c82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f5c82e",
  null
  
)

export default component.exports